























































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import {
  BMIDistribute,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import Pie from '../../_components/charts/Pie.vue'
import BarDifference from '../../_components/charts/BarDifference.vue'

@Component({
  components: {
    BasePanel,
    Pie,
    BarDifference
  }
})
export default class extends Vue {
  @Prop({}) private data!: any;
  private pieData: any = {};
  private barDataArray: Array<object> = [];
  private itemList: any = [
    {
      name: '较瘦 占比＜5%',
      color: '#3A91FF'
    },
    {
      name: '正常 5%≤占比≤85%',
      color: '#6DD400'
    },
    {
      name: '超重 85%＜占比≤95%',
      color: '#FFA100'
    },
    {
      name: '肥胖 占比＞95%',
      color: '#A35DFF'
    }
  ];
  private colorList: any = [];
  private classroomName: any = '';
  private sexName: any = '';
  private ageName: any = '';

  created() {
    if (!this.$route.query.searchParams) return
    let params = JSON.parse(this.$route.query.searchParams as string)
    localStorage.setItem('searchParams', JSON.stringify(params))
    const classroomNames: any = []
    const sexNames: any = []
    const ageNames: any = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    this.$enums.groupAnalysisAgeType.map((v: any) => {
      if (params.ageRangeTypes.indexOf(v.code) !== -1) {
        ageNames.push(v.description)
      }
    })
    this.ageName = ageNames.join('、')

    console.info(params)
    BMIDistribute(params).then((res) => {
      this.pieData = res.data.bmidistribute
      this.barDataArray = res.data.barChart || []
    })
    this.itemList.map((v: any) => {
      this.colorList.push(v.color)
    })
    // let obj: any = this.data.pie
    // obj.HeightLastTypeIntro = obj.title
    // obj.data = []
    // this.data.pie.dataList.map(v => {
    //   obj.data.push({ name: v.name, value: v.value * 100 })
    // })
    // this.list.push(obj)
    // this.data.staminaHeightPercentVoLine.map(v => {
    //   this.list.push(v)
    // })
  }
}
